const rtf = typeof Intl !== 'undefined' ? new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }) : null;

export function formatRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return 'never';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const diff = (t - now) / 1000;
  const abs = Math.abs(diff);
  if (abs < 10) return 'just now';
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['second', 60],
    ['minute', 60],
    ['hour', 24],
    ['day', 30],
    ['month', 12],
    ['year', Infinity],
  ];
  let value = diff;
  for (const [unit, size] of units) {
    if (Math.abs(value) < size) return rtf ? rtf.format(Math.round(value), unit) : `${Math.round(Math.abs(value))} ${unit}s ${value < 0 ? 'ago' : 'from now'}`;
    value /= size;
  }
  return new Date(iso).toLocaleString();
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
}

export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms < 0) return '—';
  if (ms < 1000) return `${Math.round(ms)} ms`;
  const sec = Math.round(ms / 1000);
  if (sec < 60) return `${sec} s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ${sec % 60} s`;
  const h = Math.floor(min / 60);
  return `${h} h ${min % 60} min`;
}

export function durationBetween(start?: string | null, end?: string | null, now = Date.now()): number | null {
  if (!start) return null;
  const a = new Date(start).getTime();
  const b = end ? new Date(end).getTime() : now;
  return Number.isNaN(a) || Number.isNaN(b) ? null : b - a;
}

export function formatBytes(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v >= 10 || i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
}

export const shortSha = (sha: string | null | undefined, n = 8) => (sha ? sha.slice(0, n) : '—');

/** `sha256:abcdef…` → `sha256:abcdef12…` */
export function shortDigest(digest: string): string {
  const at = digest.lastIndexOf('@');
  const d = at >= 0 ? digest.slice(at + 1) : digest;
  const [algo, hex] = d.includes(':') ? d.split(':', 2) : ['', d];
  return `${algo ? `${algo}:` : ''}${hex.slice(0, 12)}…`;
}

export function pluralize(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}

export function percent(used: number, total: number): number {
  if (!total || total <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((used / total) * 100)));
}
